export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';

export const LIST_EVENTS = 'report.LIST_EVENTS';
export const LIST_EVENTS_SUCCESS = 'report.LIST_EVENTS_SUCCESS';
export const LIST_EVENTS_FAILURE = 'report.LIST_EVENTS_FAILURE';
export const UPDATE_EVENTS_FILTER = 'report.UPDATE_EVENTS_FILTER';

export const CREATE_INVOICE = 'report.CREATE_INVOICE';
export const CREATE_INVOICE_SUCCESS = 'report.CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_FAILURE = 'report.CREATE_INVOICE_FAILURE';
export const GET_CARE_UNIT = 'report.GET_CARE_UNIT';
export const GET_CARE_UNIT_SUCCESS = 'report.GET_CARE_UNIT_SUCCESS';
export const GET_CARE_UNIT_FAILURE = 'report.GET_CARE_UNIT_FAILURE';
